<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <template slot="title">
      <div style="width: 100%">
        <span>{{ title }}</span>
        <span
          style="
            display: inline-block;
            width: calc(100% - 51px);
            padding-right: 10px;
            text-align: right;
          "
        >
          <a-button
            @click="toggleScreen"
            icon="appstore"
            style="height: 20px; width: 20px; border: 0px"
          ></a-button>
        </span>
      </div>
    </template>

    <a-spin :spinning="confirmLoading">
      <a-form-model :model="view" :rules="rules" ref="ruleForm">
        <div style="font-size: 20px; font-weight: 500">基本信息</div>
        <a-form-model-item
          label="应用AgentId"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="agentId"
        >
          <a-input
            placeholder="请输入应用AgentId (请确保唯一) "
            :disabled="view.type == 2 && actFlag == 1 ? true : false"
            v-model="view.agentId"
          />
        </a-form-model-item>
        <a-form-model-item
          label="应用Secret"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="secret"
        >
          <a-input
            placeholder="请输入应用Secret"
            :disabled="view.type == 2 && actFlag == 1 ? true : false"
            v-model="view.secret"
          />
        </a-form-model-item>
        <!-- <a-form-model-item label="同步企业微信应用信息" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-button @click="handleSubmit" type="primary" :loading="confirmLoading">同步应用信息</a-button>
        </a-form-model-item> -->
        <a-form-model-item
          label="请输入应用名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="view.type !== '1'"
          prop="name"
        >
          <a-input
            type="text"
            placeholder="请输入应用名称"
            :disabled="view.type == 2 && actFlag == 1 ? true : false"
            v-model="view.name"
          />
        </a-form-model-item>

        <a-form-model-item
          label="应用描述"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="description"
        >
          <a-input
            type="text"
            placeholder="请输入应用描述"
            :disabled="view.type == 2 && actFlag == 1 ? true : false"
            v-model="view.description"
          />
        </a-form-model-item>

        <a-form-model-item
          label="类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group v-model="view.type" @change="typeChange">
            <a-radio value="1" :disabled="title == '编辑' || title == '查看'"
              >自建应用</a-radio
            >
            <a-radio value="2" :disabled="title == '编辑' || title == '查看'"
              >官方应用</a-radio
            >
            <a-radio value="3" :disabled="true">小程序</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item
          label="状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group v-model="view.status" :defaultValue="0">
            <a-radio value="0" :disabled="title == '查看'">启用</a-radio>
            <a-radio value="1" :disabled="title == '查看'">停用</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item
          label="网页URL"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="isWeb"
        >
          <a-input
            placeholder="请输入url"
            v-model="view.homeUrl"
            :readOnly="status ? false : !!model.agentId"
          />
        </a-form-model-item>

        <a-form-model-item
          label="appid"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="isMiniprogram"
        >
          <a-input
            placeholder="请输入appid"
            :readOnly="status ? false : !!model.agentId"
          />
        </a-form-model-item>
        <a-form-model-item
          label="展示标题"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="isMiniprogram || isWeb"
        >
          <a-input
            placeholder="请输入标题"
            :max-length="32"
            v-model="view.name"
            :readOnly="status ? false : !!model.agentId"
          />
        </a-form-model-item>
        <a-form-model-item
          label="页面路径"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="isMiniprogram"
        >
          <a-input
            placeholder="请输入路径"
            :readOnly="status ? false : !!model.agentId"
          />
        </a-form-model-item>
        <a-form-model-item
          label="应用图标"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="isWeb && status"
        >
          <j-image-upload
            class="avatar-uploader"
            text="上传"
            file-type="file"
            fileKey="picFile"
            v-model="avatar_mediaid"
            url="wechatwork-groupchat-biz/wechatwork/wechatMsg/upFile"
            accept=".jpg, .png"
            @getFileList="_getFileList"
          ></j-image-upload>
        </a-form-model-item>
      </a-form-model>
    </a-spin>

    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem" v-show="status">取消</a-button>
      </a-popconfirm>
      <a-button
        @click="handleSubmit"
        type="primary"
        :loading="confirmLoading"
        v-show="status"
        >提交</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import moment from 'moment';
import Vue from 'vue';
import JSelectPosition from '@/components/jeecgbiz/JSelectPosition';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { getAction } from '@/api/manage';
import { queryall, editList, editSubmit, getFileIOByMediaId } from '@/api/api';
import { disabledAuthFilter } from '@/utils/authFilter';
import JImageUpload from '../../../components/jeecg/JImageUpload';

export default {
  name: 'AgentModal',
  components: {
    JImageUpload,
    JSelectPosition
  },
  data() {
    return {
      view: {
        name: '',
        secretInfo: '',
        type: '',
        homeUrl: '',
        description: '',
        status: '',
        agentId: '',
        secret: ''
      },
      logoMediaId: '',
      status: true,
      modalWidth: 800,
      drawerWidth: 700,
      modaltoggleFlag: true,
      confirmDirty: false,
      disableSubmit: false,
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      rules: {
        name: [{ required: true, message: '请输入应用名称!' }],
        agentId: [{ required: true, message: '请输入应用AgentId!' }],
        secret: [{ required: true, message: '请输入应用Secret!' }],
        description: [
          { required: true, min: 4, message: '请输入应用描述!(不小于4个字符)' }
        ]
      },
      uploadLoading: false,
      confirmLoading: false,
      headers: {},
      actFlag: {},
      form: this.$form.createForm(this),
      picUrl: '',
      url: {
        // fileUpload: process.env.VUE_APP_GATEWAY_URL + process.env.VUE_APP_CMS_SYSTEM+"/sys/common/upload",
      },
      external_attr: {
        name: '官方小程序',
        type: '0',
        text: {
          value: ''
        },
        web: {
          url: '',
          title: ''
        },
        miniprogram: {
          appid: '',
          title: '',
          pagepath: ''
        }
      },
      fileList: [],
      avatar_mediaid: ''
    };
  },
  created() {
    const token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = { 'X-Access-Token': token };
  },
  computed: {
    uploadAction: function() {
      return this.url.fileUpload;
    },
    // isValue() {
    //   return this.view.type === "1"
    // },
    isWeb() {
      return this.view.type === '1';
    },
    isMiniprogram() {
      return this.view.type === '3';
    }
  },
  // inject: ['reload'],
  methods: {
    _getFileList(fileList) {
      console.log(fileList);
      if (fileList.length > 0) {
        this.avatar_mediaid = fileList[0].response.result.mediaId;
      }
      console.log(this.avatar_mediaid);
    },
    isInit(record) {
      if (record.hasOwnProperty('agentid')) {
        this.actFlag = '1';
      } else {
        this.actFlag = '0';
      }
      const that = this;
      this.model = record;
      let formData = Object.assign(this.model);
      formData.agentId = this.model.agentid;
      formData.type = this.model.type;
      editList(formData).then(res => {
        console.log('888888');

        if (res.success) {
          this.view.secretInfo = res.result.secret;
          // that.form.setFieldsValue({
          //   agentId: res.result.agentid,
          //   secret: this.secretShow(res.result.secret),
          //   // name: res.result.name,
          // })
          this.view.secret = this.secretShow(res.result.secret);
          this.view.agentId = res.result.agentid;
          this.view.description = res.result.description;
          this.view.homeUrl = res.result.home_url;
          console.log('22222', res);
          this.view.type = res.result.type.toString();
          this.view.name = res.result.name;
          this.view.status = res.result.status;
        } else {
          // this.form.setFieldsValue({
          //   agentId: '',
          //   secret: '',
          //   // name: '',
          //   // description: ''
          // })
          this.view.secret = '';
          this.view.agentId = '';
          this.view.name = '';
          this.view.type = '2';
          this.view.description = '';
        }
      });
    },
    secretShow(sercret) {
      var str = '';
      let secretArr = [...sercret];
      secretArr.map((res, index) => {
        if (index > 10 && index < 30) {
          str += '*';
        } else {
          str += res;
        }
      });
      return str;
    },
    isDisabledAuth(code) {
      return disabledAuthFilter(code);
    },
    //窗口最大化切换
    toggleScreen() {
      if (this.modaltoggleFlag) {
        this.modalWidth = window.innerWidth;
      } else {
        this.modalWidth = 800;
      }
      this.modaltoggleFlag = !this.modaltoggleFlag;
    },
    add() {
      this.picUrl = '';
      this.edit({ activitiSync: '1' });
      this.title = '新增';
    },
    viewInfo(record) {
      this.status = false;
      this.edit(record);
      this.title = '查看';
    },
    edit(record) {
      console.log(record);
      this.view.type = record.type;
      this.resetScreenSize(); // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度
      this.isInit(record);
      if (record.hasOwnProperty('id')) {
        setTimeout(() => {
          this.fileList = record.avatar;
        }, 5);
      }
      this.visible = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.form.setFieldsValue(
            pick(this.model, 'agentId', 'secret', 'avatar_mediaid')
          );
        });
      });
    },
    close() {
      this.$emit('close');
      this.$refs.ruleForm.resetFields();
      this.visible = false;
      this.disableSubmit = false;
      this.fileList = [];
      this.status = true;
    },
    moment,
    handleSubmit() {
      const that = this;
      // 触发表单验证
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          that.confirmLoading = true;
          // that.view.logoMediaId = that.fileList;
          // console.log(that.view.logoMediaId+"---------------------")
          let formData = Object.assign(this.view);
          formData.flag = this.actFlag;
          formData.status = this.view.status;
          formData.name = this.view.name;
          if (formData.secret.indexOf('*') != -1) {
            formData.corpSecret = that.view.secretInfo;
          } else {
            formData.corpSecret = that.view.secret;
          }
          editSubmit(formData)
            .then(res => {
              console.log(res.errmsg);
              if (res.errcode === 0) {
                that.$message.success(
                  this.actFlag == '1' ? '编辑成功！' : '新增成功！'
                );
                this.$emit('ok');
                this.close();
              } else {
                that.$message.error(res.errmsg);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },

    normFile(e) {
      console.log('Upload event:', e);
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    beforeUpload: function(file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        return false;
      }
      //TODO 验证文件大小
    },
    handleChange(info) {
      this.picUrl = '';
      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }
      if (info.file.status === 'done') {
        var response = info.file.response;
        this.uploadLoading = false;
        console.log(response);
        if (response.success) {
          this.model.avatar = response.message;
          this.picUrl = 'Has no pic url yet';
        } else {
          this.$message.warning(response.message);
        }
      }
    },

    // 根据屏幕变化,设置抽屉尺寸
    resetScreenSize() {
      let screenWidth = document.body.clientWidth;
      if (screenWidth < 500) {
        this.drawerWidth = screenWidth;
      } else {
        this.drawerWidth = 700;
      }
    },
    typeChange(e) {
      this.view.type = e.target.value;
    },
    onTypeChange(e) {},
    _getFileList(fileList) {
      console.log('fileList', fileList);

      if (fileList.length > 0 && fileList) {
        let mediaId = fileList[fileList.length - 1].response.result.mediaId;
        // process.env.VUE_APP_CMS_GROUPCHAT+"/wechatwork/wechatMsg/getFileIOByMediaId"
        getFileIOByMediaId({ mediaId }).then(res => {
          if (res.success) {
            this.avatar_mediaid = mediaId; //process.env.VUE_APP_CMS_MINIOURL+res.result;
            let url = process.env.VUE_APP_CMS_MINIOURL + res.result;
            this.avatarUrl = res.result;
            console.log(this.avatar_mediaid);
            this.avatar_mediaid = url;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}

.ant-upload-select-picture-card i {
  font-size: 49px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
